"use strict";
var appn;
(function (appn) {
    var ajax;
    (function (ajax) {
        function baseAjax(appnAjaxSettings, method) {
            if (!appnAjaxSettings.url) {
                appn.log.warning('appn.ajax called with no url.');
                return;
            }
            const $ajaxSettings = {
                headers: appn.verifyHeader,
                url: appnAjaxSettings.url,
                data: appnAjaxSettings.data,
                contentType: appnAjaxSettings.contentType === undefined ? 'application/x-www-form-urlencoded; charset=UTF-8' : appnAjaxSettings.contentType,
                type: method,
                cache: false,
                processData: appnAjaxSettings.processData === undefined ? true : appnAjaxSettings.processData
            };
            if (appnAjaxSettings.dataType)
                $ajaxSettings.dataType = appnAjaxSettings.dataType;
            appn.log.info(`appn.ajax ${method} STARTED`);
            appn.log.info($ajaxSettings);
            $.ajax($ajaxSettings)
                .done(function (data, textStatus, jqXHR) {
                if (appnAjaxSettings.done)
                    appnAjaxSettings.done(data, textStatus, jqXHR);
                appn.log.info(`appn.ajax ${textStatus}`);
            })
                .fail(function (jqXHR, textStatus, errorThrown) {
                if (appnAjaxSettings.fail)
                    appnAjaxSettings.fail(jqXHR, textStatus, errorThrown);
                appn.log.error(`appn.ajax ${textStatus}`);
            })
                .always(function (dataOrJqXHR, textStatus, jqXHROrErrorThrown) {
                if (appnAjaxSettings.always)
                    appnAjaxSettings.always(dataOrJqXHR, textStatus, jqXHROrErrorThrown);
                appn.log.info(`appn.ajax ${method} FINISHED`);
            });
        }
        function get(appnAjaxSettings) {
            baseAjax(appnAjaxSettings, 'GET');
        }
        ajax.get = get;
        function post(appnAjaxSettings) {
            baseAjax(appnAjaxSettings, 'POST');
        }
        ajax.post = post;
    })(ajax = appn.ajax || (appn.ajax = {}));
})(appn || (appn = {}));
